module.exports = __webpack_public_path__ + "static/media/T4.6063f9ab.jpg";